module.exports = __webpack_public_path__ + "static/jackCross-55dadb4fbd4c517a2f4f93b77a3f8f01.jpg";